@import "../../../../shared/scss";

$drawer-width: (
  "mobile": 100%,
  "m": p-px-to-rem(336px),
  "l": p-px-to-rem(405px),
  "xxl": p-px-to-rem(606px),
  "default": p-px-to-rem(330px),
);

:host {
  .phn-nd-contextual-drawer {
    float: inline-end;
    translate: calc(var(--isLTR, 1) * -1000px);
    box-sizing: border-box;
    position: fixed;
    inset-block-start: 0;
    block-size: 100vh;
    z-index: $phn-z-index-mega-flyout + 1;

    @include pds-media-query-min-max("base", "s") {
      inline-size: map-get($drawer-width, "mobile");
      border-radius: 0;
      background-color: $main-drawer-mobile-background-color;
    }

    @include pds-media-query-min("s") {
      inline-size: 43.5%;
      border-radius: 0;
      background-color: $main-drawer-mobile-background-color;
    }

    @include pds-media-query-min("m") {
      inline-size: 33%;
    }

    @include pds-media-query-min("xxl") {
      max-inline-size: map-get($drawer-width, "xxl");
    }

    &.translate-in-from-left {
      @media (prefers-reduced-motion: no-preference) {
        animation: translate-in-from-left $pds-motion-duration-long
          $pds-motion-easing-in;
      }
    }

    &.translate-out-to-left {
      @media (prefers-reduced-motion: no-preference) {
        animation: translate-in-from-left $pds-motion-duration-long
          $pds-motion-easing-out reverse;
      }
    }

    .contextual-drawer-backdrop {
      position: fixed;
      z-index: $phn-z-index-mega-flyout;
      inset: 0;
      background-color: rgba(0, 0, 0, 0);
      opacity: 0;
      inline-size: calc(100vw + 1000px);
      cursor: pointer;
      @include pds-frosted-glass();

      &.fade-in-animation {
        animation: fade-in-animation 400ms;
      }

      &.fade-out-animation {
        animation: fade-in-animation 400ms reverse;
      }
    }

    .close-button {
      position: absolute;
      inset-inline-end: p-px-to-rem(-70px);
      inset-block-start: p-px-to-rem(10px);
      z-index: $phn-z-index-mega-flyout + 1;

      @include pds-media-query-min-max("base", "s") {
        display: none;
      }
    }

    .contextual-drawer {
      background-color: $main-drawer-background-color;
      position: relative;
      overflow-y: auto;
      overflow-block: auto;
      overflow-x: hidden;
      overflow-inline: hidden;
      border-radius: 0 4px 4px 0;
      block-size: 100vh;
      z-index: $phn-z-index-mega-flyout + 1;
    }
  }
}
